import React from 'react';
import { useWatch } from 'react-hook-form';
import { QuestionListSheet } from '../QuestionListSheet';

/**
 * The editor's question list.
 *
 * It reads the questions through the form rather than through the field array,
 * which only restates itself when a question is added or removed: a row has to
 * show the question as it is being typed, not as it was when the quiz loaded.
 *
 * Props:
 *   control (object) - react-hook-form control for the editor's form.
 *   ...             - The rest are passed straight to QuestionListSheet.
 */
export const EditorQuestionListSheet = ({ control, ...props }) => {
  const questions = useWatch({ control, name: 'questions' }) ?? [];

  return (
    <QuestionListSheet questions={questions.map((question) => question.question)} {...props} />
  );
};
